var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen flex flex-col justify-center gap-1 place-items-center text-center"},[_c('div',{staticClass:"text-2xl"},[_vm._v(" Заказ успешно создан ")]),_c('div',[_vm._v(" Для его оплаты вернитесь в бота ")])])
}]

export { render, staticRenderFns }